import React from "react";
import {connect} from "react-redux";
import {Translate} from "react-localize-redux";
import {Empty} from "antd";
import {Nullable} from "@data-force/app";
import {ContentType} from "../../../enums/enums";
import "./ContentEmpty.scss";
import StoreState from "../../../interfaces/store/storeState";
import {NoContentIcon} from "../../../assets/Icons";
import {getLocalePrefix} from "../../../utils/common";

interface OwnProps {
    type: string
}

interface StateProps {
    visitWebsiteUrl: string
    isTest: Nullable<boolean>
}

type Props = OwnProps & StateProps;

const ContentEmpty: React.FC<Props> = ({type, visitWebsiteUrl, isTest}: Props): React.ReactElement => {
    const translatePath: string = "components.ContentEmpty.ContentEmpty";
    const showAdditionalTxt: boolean = type === ContentType.AVAILABLE;
    const localePrefix: string = getLocalePrefix(isTest);

    return (
        <Empty
            image={<NoContentIcon/>}
            description={(
                <>
                    <div>
                        <Translate id={`${translatePath}.${type}.${localePrefix}EmptyTxt.text`}/>
                    </div>
                    {!isTest && showAdditionalTxt
                    && (
                        <a
                            className="df-content-empty"
                            rel="noopener noreferrer"
                            href={visitWebsiteUrl}
                            target="_blank"
                        >
                            <Translate id={`${translatePath}.websiteVisitText.text`}/>
                        </a>
                    )}
                </>
            )}
        />
    );
};

function mapStateToProps(state: StoreState): StateProps {
    return {
        visitWebsiteUrl: state.serviceProperties.visitWebsiteUrl,
        isTest: state.job.isTest,
    };
}

export default connect(mapStateToProps)(ContentEmpty);
